import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import QRCodeDisplay from './components/QRCodeDisplay';
import QRCodeDisplayV2 from './components/QRCodeDisplayV2';
import ManageConnection from './components/ManageConnection';
import Home from './components/Home';
import JCalHome from './components/JCalHome';
import UnderConstruction from './components/UnderConstruction';
import AdminPanel from './components/AdminPanel';
import AdminSecretGate from './components/AdminSecretGate';
import AccountDeletionRequest from './components/AccountDeletionRequest';
import PrivacyPolicy from './components/PrivacyPolicy';
import JCalPrivacyPolicy from './components/JCalPrivacyPolicy';
import JCalTermsOfService from './components/JCalTermsOfService';
import JCalFeedback from './components/JCalFeedback';

const getActiveBrand = () => {
    if (process.env.REACT_APP_BRAND) return process.env.REACT_APP_BRAND;
    const host = window.location.hostname;
    if (host === 'jcal.app' || host === 'www.jcal.app' || host.endsWith('.jcal.app')) return 'jcal';
    return 'happtrak';
};

const isUnderConstruction = () => {
    const flag = (process.env.REACT_APP_UNDER_CONSTRUCTION || '').trim().toLowerCase();
    return flag === 'true' || flag === '1' || flag === 'yes';
};

const isAuthenticated = () => {
    // Check if the user is logged in (use token, session, or localStorage)
    return !!localStorage.getItem('userToken');
};

const ProtectedRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

const App = () => {
    const showUnderConstruction = isUnderConstruction();
    const brand = getActiveBrand();

    return (
        <Router>
            <Routes>
                <Route path="/" element={brand === 'jcal' ? <JCalHome /> : showUnderConstruction ? <UnderConstruction /> : <Home />} />
                <Route path="/jcal" element={<JCalHome />} />
                <Route path="/jcal-v1" element={<Navigate to="/jcal" replace />} />
                <Route path="/jcal-v2" element={<Navigate to="/jcal" replace />} />
                <Route path="/privacy" element={brand === 'jcal' ? <JCalPrivacyPolicy /> : <PrivacyPolicy />} />
                <Route path="/tos" element={<JCalTermsOfService />} />
                <Route path="/feedback" element={<JCalFeedback />} />
                <Route path="/jcal/privacy" element={<Navigate to="/privacy" replace />} />
                <Route path="/jcal/tos" element={<Navigate to="/tos" replace />} />
                <Route path="/delete-account" element={<AccountDeletionRequest />} />
                <Route path="/jcal/delete-account" element={<AccountDeletionRequest app="jcal" />} />
                <Route path="/login" element={<AdminSecretGate><Login /></AdminSecretGate>} />
                <Route path="/register" element={<AdminSecretGate><Register /></AdminSecretGate>} />
                <Route
                    path="/qr-code/:user_id"
                    element={
                        <ProtectedRoute>
                            <QRCodeDisplay />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/qr-code-v2/:user_id"
                    element={
                        <ProtectedRoute>
                            <QRCodeDisplayV2 />
                        </ProtectedRoute>
                    }
                />
                <Route path="/manage-connection/:userId" element={<ManageConnection />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
};

export default App;
